import { ReceiptBindingDataContract } from 'models'

export default function getSampleKitchenReceipt(): ReceiptBindingDataContract {
    return {
        order: {
            tableName: 'Mock',
            orderNo: 'Test-001',
            orderDateTime: new Date().toISOString(),
            orderLines: [
                {
                    orderLineID: '67cb7729-ab8d-41f2-9b4e-4e18284dadb9',
                    itemName: 'Cheese Burger',
                    orderQuantity: 2,
                    subtotal: 5.18,
                    refOrderLineID: null,
                },
                {
                    orderLineID: 'f54b4340-2e09-4125-82a7-89976f0f94de',
                    itemName: 'Orange Juice',
                    orderQuantity: 1,
                    subtotal: 2.29,
                    refOrderLineID: null,
                },
            ],
        },
        customer: {
            givenName: 'Jane Doe',
        },
        saleNo: null,
        tipAmount: 0,
        totalDueAmount: 7.47,
        balanceDueAmount: 7.5,
    }
}
